<template>
  <div>
    <logged-in-header />
    <edit-organization-profile-panel class="bodyPanel" />
    <empower-footer />
    <whats-app />
  </div>
</template>

<script>
import loggedInHeader from "../../components/commom/LoggedInHeader";
import editOrganizationProfilePanel from "../../components/organization/EditOrganizationProfilePanel";
import empowerFooter from "../../components/commom/EmpowerFooter";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  components: {
    loggedInHeader,
    editOrganizationProfilePanel,
    empowerFooter,
    WhatsApp
  }
};
</script>
<style scoped>
.bodyPanel {
  background-color: #e9e9e9;
}
</style>
